const invoiceLabels = [
    {
        title: 'Factura',
        type: 'columns',
        fields: [
            { label: '[NUMERO]', description: 'invoice_number', visible: true },
            {
                label: '[TOTALFACTURA]',
                description: 'invoice_total',
                visible: true
            }
        ]
    },
    {
        title: 'Cliente',
        type: 'columns',
        fields: [
            {
                label: '[NOMBRECLIENTE]',
                description: 'customer_name',
                visible: true
            },
            {
                label: '[APELLIDOCLIENTE]',
                description: 'customer_lastname',
                visible: true
            },
            {
                label: '[NUMEROCLIENTE]',
                description: 'customer_number',
                visible: true
            },
            {
                label: '[NUMEROCASILLERO]',
                description: 'pobox_number',
                visible: true
            },
            {
                label: '[USUARIOCASILLERO]',
                description: 'pobox_username',
                visible: true
            }
        ]
    },
    {
        title: 'Agencia y Empresa',
        type: 'columns',
        fields: [
            {
                label: '[NOMBREEMPRESA]',
                description: 'company_name',
                visible: true
            },
            {
                label: '[NOMBREAGENCIA]',
                description: 'agency_name',
                visible: true
            },
            {
                label: '[DIRECCIONAGENCIA]',
                description: 'agency_address',
                visible: true
            },
            {
                label: '[EMAILAGENCIA]',
                description: 'agency_email',
                visible: true
            },
            {
                label: '[TELEFONOAGENCIA]',
                description: 'agency_phone',
                visible: true
            },
            {
                label: '[LINKEMPRESA]',
                description: 'link_company',
                visible: true
            },
            { label: '[AGENTE]', description: 'agent_name', visible: true }
        ]
    },
    {
        title: 'Pagos',
        type: 'columns',
        fields: [
            {
                label: '[PAIDINVOICEAMOUNT]',
                description: 'paid_amount',
                visible: true
            },
            {
                label: '[UNPAIDINVOICEAMOUNT]',
                description: 'unpaid_amount',
                visible: true
            },
            {
                label: '[LINKPAGOSTRIPE]',
                description: 'stripe_payment_link',
                visible: true
            }
        ]
    }
];

export default invoiceLabels;
